"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseGoogleMapsLink = exports.generateGoogleMapsUrl = void 0;
const geoLocationToQueryString = (geoLocation) => `${geoLocation.lat},${geoLocation.lng}`;
const removeNullValues = (object) => Object.fromEntries(Object.entries(object).filter(([_, value]) => value !== null));
const generateGoogleMapsUrl = (query) => {
    const scrubbedQuery = removeNullValues({ ...query });
    return `https://www.google.com/maps/search/?api=1&query=${"placeId" in scrubbedQuery
        ? `Google&query_place_id=${scrubbedQuery.placeId}`
        : geoLocationToQueryString(scrubbedQuery.geoLocation)}`;
};
exports.generateGoogleMapsUrl = generateGoogleMapsUrl;
function parseGoogleMapsLink(text) {
    const match = text.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/) ??
        text.match(/[?&]q=(-?\d+\.\d+),(-?\d+\.\d+)/);
    if (!match)
        return null;
    return { lat: parseFloat(match[1]), lng: parseFloat(match[2]) };
}
exports.parseGoogleMapsLink = parseGoogleMapsLink;
//# sourceMappingURL=index.js.map